module.exports = __webpack_public_path__ + "img/user-selected.2452b358.svg";